import React, { useState, useEffect } from 'react';
import '../catalogue/styles.css';
import VisibleIcon from '@rsuite/icons/Visible';
import { Link } from 'react-router-dom';
import {
  Input,
  InputGroup,
  Button,
  CheckPicker,
  Checkbox,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Col,
  FlexboxGrid,
  Container,
  Notification,
  IconButton,
  SelectPicker,
  Drawer,
  Pagination
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import DrawerView from './DrawerView';

interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
const Selection = () => {
  const ipp = 'http://192.168.1.23:1337';
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const handleCheckAll = (value, checked) => {
    if (checked) {
      setSelectedItems(data123.map((item) => item.id)); // Replace "id" with your unique identifier property
    } else {
      setSelectedItems([]);
    }
  };
  const handleCheckboxChange = (value, checked) => {

    if (checked) {
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, value]);
    } else {
      setSelectedItems((prevSelectedItems) => prevSelectedItems.filter((item) => item !== value));
    }
  };
  const handleCartClose = () => {
    setIsCartOpen(false);
  };
  const [showDrawer, setShowDrawer] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const subcategory = ['Fabric (3)', 'Finishing (4)', 'Metal (8)', 'Packing (5)', 'Verse (6)', 'Wooden (2)', 'Packing (5)'].map(
    item => ({ label: item, value: item })
  );
  const AddedOn = ['Today', 'Yesterday', 'This week', 'Last week', 'This month', 'Last month', 'Last 3 month', 'Last 6 month'].map(
    item => ({ label: item, value: item })
  );

  // Api Start
  const [data123, setData123] = useState([]);
  const [meta123, setMeta123] = useState<MetaData>();
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 25,
    pageCount: 1,
    total: 0,
  });
  useEffect(() => {
    fetchData();
  }, [data123]);

  const fetchData = async () => {
    const response = await fetch(`${ipp}/api/products?populate=*&pagination[page]=${activePage}`);
    const json = await response.json();
    setData123(json.data);
    setMeta123(json.meta);
    setPagination(json.meta.pagination);
  };
  const ip = ipp;
  const [activePage, setActivePage] = React.useState(1);
  // Api End

  const [categorydata, setCategorydata] = React.useState([]);
  useEffect(() => {
    fetchData3();
  }, []);
  const fetchData3 = async () => {
    try {
      const response = await fetch(`${ip}/api/mstcategories`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.CategoryName,
        value: item.attributes.CategoryCode,
      }));
      setCategorydata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [productypedata, setProductypedata] = React.useState([]);
  useEffect(() => {
    fetchDatap();
  }, []);
  const fetchDatap = async () => {
    try {
      const response = await fetch(`${ip}/api/mstproducttypes`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.ProductTypeName,
        value: item.attributes.ProductTypeCode,
      }));
      setProductypedata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [finsihdata, setdFinishata] = React.useState([]);
  useEffect(() => {
    fetchDataf();
  }, []);
  const fetchDataf = async () => {
    try {
      const response = await fetch(`${ip}/api/mstfinishes`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.FinishName,
        value: item.attributes.FinishCode,
      }));
      setdFinishata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [materialdata, setMaterialdata] = React.useState([]);
  useEffect(() => {
    fetchDataM();
  }, []);
  const fetchDataM = async () => {
    try {
      const response = await fetch(`${ip}/api/mstmaterials`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.MaterialName,
        value: item.attributes.MaterialCode,
      }));
      setMaterialdata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [hsndata, setHsndata] = React.useState([]);
  useEffect(() => {
    fetchDatah();
  }, []);
  const fetchDatah = async () => {
    try {
      const response = await fetch(`${ip}/api/msthscodes`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.hscode,
        value: item.attributes.hscode,
      }));
      setHsndata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [colordata, setColordata] = React.useState([]);
  useEffect(() => {
    fetchDataco();
  }, []);
  const fetchDataco = async () => {
    try {
      const response = await fetch(`${ip}/api/mstcolors`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.ColorName,
        value: item.attributes.ColorCode,
      }));
      setColordata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);
  const [selectedFinish, setSelectedFinish] = useState([]);
  const [selectedhsn, setSelectedhsn] = useState([]);
  const [selectedmaterial, setSelectedmaterial] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  
  const handleSearch = (value) => {
    setSearchQuery(value);
  };

  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
    
  };
  
  const handleProductTypeChange = (value) => {
    setSelectedProductType(value);
  };
  
  const handleColorChange = (value) => {
    setSelectedColor(value);
  };

  const handleFinishChange = (value) => {
    setSelectedFinish(value);
  };

  const handleHSNChange = (value) => {
    setSelectedhsn(value);
  };

  const handleMaterialChange = (value) => {
    setSelectedmaterial(value);
  };



  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start' >
              <h3 className="title">Catalogues</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Select Product</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack spacing={5}>
            <CheckPicker
              data={categorydata}
              placeholder="Select Category"
              value={selectedCategory}
              onChange={handleCategoryChange}
              block
            />
            {/* <CheckPicker data={categorydata} size="xs" appearance="default" placeholder="Category" style={{ width: 116 }} /> */}

            {/* <CheckPicker data={data1} size="xs" appearance="default" placeholder="Sub Category" style={{ width: 116 }} /> */}
            <CheckPicker
              data={productypedata}
              placeholder="Product Type"
              value={selectedProductType}
              onChange={handleProductTypeChange}
              block
            />
            
              <SelectPicker data={AddedOn} size="xs" appearance="default" placeholder="Added On" style={{ width: 116 }} />
              <SelectPicker data={AddedOn} size="xs" appearance="default" placeholder="Updated On" style={{ width: 116 }} />
              <Button appearance="default" active onClick={() => setShowDrawer(true)}>
                More Filter
              </Button>
            </Stack>
          </Stack>
          <Stack direction='column' alignItems='flex-end' spacing={53}>
            <Stack direction='row' spacing={5}>
              <InputGroup inside >
              <Input placeholder="Search" type="text" value={searchQuery} onChange={handleSearch} />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
              <Button appearance="default" active>
                <SearchIcon /> Smart Search
              </Button>
            </Stack>
            <Stack spacing={10}>
              <Checkbox
                indeterminate={selectedItems.length > 0 && selectedItems.length < data123.length}
                checked={selectedItems.length === data123.length}
                onChange={handleCheckAll}
              >
                Select all
              </Checkbox>
              <Button appearance="default" active>
                Product ID Desc
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <Divider className='divide' />
        <div className="row">
          <Panel>
            {meta123 && (
              <b style={{ marginLeft: '6px' }}>Total Products: {meta123.pagination.total}</b>
            )}
            {/* <CheckboxGroup inline name="checkboxList" value={value} onChange={handleChange1} > */}
            <FlexboxGrid justify="space-between" style={{ textAlign: 'center' }}>
              {data123
              .filter(item => {
                // Filter based on the search query
                 // Master Search
                 const ProductName = item.attributes.ProductName ? item.attributes.ProductName.toLowerCase(): '';
                 const AliasCode = item.attributes.ProductId ? item.attributes.ProductId.toLowerCase(): '';
                 const ColorName = item.attributes.ColorName ? item.attributes.ColorName.toLowerCase(): '';  
                 const HSNCode = item.attributes.HSNCode ? item.attributes.HSNCode.toLowerCase(): '';
                 const CategoryName = item.attributes.CategoryName ? item.attributes.CategoryName.toLowerCase() : '';
                 const FinishName = item.attributes.FinishName ? item.attributes.FinishName.toLowerCase() : '';
                 const SearchKeyword = item.attributes.SearchKeyword ? item.attributes.SearchKeyword.toLowerCase() : '';
                 const MOQ = item.attributes.MOQ ? item.attributes.MOQ.toLowerCase() : '';
                 const ProductDesigner = item.attributes.ProductDesigner ? item.attributes.ProductDesigner.toLowerCase() : '';
                 const MadeBy = item.attributes.MadeBy ? item.attributes.MadeBy.toLowerCase() : '';
                 const ProductTypeName = item.attributes.ProductTypeName ? item.attributes.ProductTypeName.toLowerCase() : '';
                 // Master Search
 
                 
 
                 const cataCode = item.attributes.CategoryCode;
                 const productTypecode = item.attributes.ProductTypeCode;
                 const colorcode = item.attributes.ColorCode;
                 const finishcode = item.attributes.FinishCode;
                 const hsncode = item.attributes.hscode;
                 const materialcode = item.attributes.MaterialCode;
                 
 
                 const categoryMatch = selectedCategory.length === 0 || selectedCategory.includes(cataCode);
                 const productTypeMatch = selectedProductType.length === 0 || selectedProductType.includes(productTypecode);
                 const colorMatch = selectedColor.length === 0 || selectedColor.includes(colorcode);
                 const finishMatch = selectedFinish.length === 0 || selectedFinish.includes(finishcode);
                 const hsnMatch = selectedhsn.length === 0 || selectedhsn.includes(hsncode);
                 const materialMatch = selectedmaterial.length === 0 || selectedmaterial.includes(materialcode);
 
                 return (
                   // Master Search
                   ProductName.includes(searchQuery.toLowerCase()) ||
                   AliasCode.includes(searchQuery.toLowerCase()) ||
                   ColorName.includes(searchQuery.toLowerCase()) ||
                   CategoryName.includes(searchQuery.toLowerCase()) ||
                   HSNCode.includes(searchQuery.toLowerCase()) ||
                   FinishName.includes(searchQuery.toLowerCase()) ||
                   SearchKeyword.includes(searchQuery.toLowerCase()) ||
                   MOQ.includes(searchQuery.toLowerCase()) ||
                   ProductDesigner.includes(searchQuery.toLowerCase()) ||
                   MadeBy.includes(searchQuery.toLowerCase()) ||
                   ProductTypeName.includes(searchQuery.toLowerCase()) 
                  
                   // Master Search
                  
                 )&& categoryMatch && productTypeMatch && colorMatch && finishMatch && hsnMatch && materialMatch;
              })
              .map((item) => (
                <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                    <Panel className='box' bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Stack><Checkbox
                      value={item.id} // Replace "id" with your unique identifier property
                      checked={selectedItems.includes(item.id)}
                      onChange={(value, checked) => handleCheckboxChange(value, checked)}
                    /></Stack>
                      <img src={`${ip}${item.attributes.CoverImage.data.attributes.url}`} className='imgp' />
                      {/* <div className="overlay">Quick Veiw</div> */}
                      <Panel>
                        <b>Product Name : {item.attributes.ProductName} </b>
                        <p>
                          Alias Code : {item.attributes.ProductId}
                        </p>
                      </Panel>
                    </Panel>
                  
                </FlexboxGrid.Item>
              ))}
            </FlexboxGrid>
            
            {selectedItems.length > 0 && (
              <Notification type="success"
                onClose={handleCartClose}
                style={{
                  position: 'fixed',
                  top: '80%', right: 20, 
                  transform: 'translateY(-50%)', 
                  zIndex: 9999, 
                  background: 'rgb(34 171 189)', 
                  color: 'white', 
                  width: '20%',
                }}>
                <b style={{ color: 'white' }}>Selected Products : {selectedItems.length}</b>
                <Divider />
                <Link to={{ pathname: '/editDetails', search: `?selectedItems=${selectedItems.join(',')}` }} >   
                 <IconButton icon={<VisibleIcon />}><b>View</b></IconButton>
                </Link>
              </Notification>
            )}
          </Panel>
          <Stack justifyContent='flex-end'>
          {pagination.pageCount > 1 && (
          <Pagination
        prev
        last
        next
        first
        size="xs"
        total={pagination.total}
        limit={pagination.pageSize}
        activePage={pagination.page}
        onChangePage={setActivePage}
      />
          )}
      </Stack>
        </div>
        <Drawer size="xs" backdrop="static" open={showDrawer} onClose={() => setShowDrawer(false)}>
        <Drawer.Header>
          <Drawer.Title>Filters</Drawer.Title>
          <Drawer.Actions>
            <Button onClick={() => setShowDrawer(false)} appearance="ghost" color="cyan">Cancel</Button>
            <Button onClick={() => setShowDrawer(false)} appearance="primary"color="cyan" >
              Confirm
            </Button>
          </Drawer.Actions>
        </Drawer.Header>
        <Drawer.Body>
        <Stack direction='column' alignItems='center'>
        <CheckPicker value={selectedColor}
              onChange={handleColorChange} data={colordata} placement="autoVerticalStart" placeholder="Select Color" style={{ width: 350,  marginBottom: 20 , marginTop:20   }} />
        <CheckPicker value={selectedFinish}
              onChange={handleFinishChange} data={finsihdata} placement="autoVerticalStart" placeholder="Select Finish" style={{ width: 350,  marginBottom: 20 }} />
        <CheckPicker value={selectedhsn}
              onChange={handleHSNChange} data={hsndata} placement="autoVerticalStart" placeholder="Select HSN" style={{ width: 350,  marginBottom: 20}} />
        <CheckPicker value={selectedmaterial}
              onChange={handleMaterialChange} data={materialdata} placement="autoVerticalStart" placeholder="Select Material" style={{ width: 350,  marginBottom: 20 }} />
        </Stack>
        </Drawer.Body>
      </Drawer>
        <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
          <div className="container">
            <p>© All Right Reserved. Product by </p>
          </div>
          <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        </Stack>
        
      </Container>
    </>
  );
};
export default Selection;